<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { asyncSave } from "@/api/publishOnline"
export default {
	data(){
		return {
      		pathArr:[
      		  // PCPath： PC端路由；mPath：移动端路由
      		  {pcPath: '/',mPath:'/home'}, //首页
      		  {pcPath: '/index',mPath:'/home'}, //首页
      		  {pcPath: '/xszt',mPath:'/mserve?moCode=xszt&name=学术专题'}, // 学术专题
      		  {pcPath: '/zxsc',mPath:'/mserve?moCode=zxsc&name=在线书城'}, // 在线书城
      		  {pcPath: '/zxkc',mPath:'/mserve?moCode=zxkc&name=在线课程'}, // 在线课程
      		  {pcPath: '/hyfw',mPath:'/mserve?moCode=hyfw&name=行业服务'}, // 行业服务
      		  {pcPath: '/search',mPath:'/searesu'}, // 商品详情页
      		//   {pcPath: '/productInfo',mPath:'/goodsDto'}, // 商品详情页
      		//   {pcPath: '/packageDetails',mPath:'/goodsDto'}, // 商品详情页
      		//   {pcPath: '/pcPreview',mPath:'/goodsDto'}, // 商品详情页
      		]
		}
	},
	watch: {
    	$route: {
    	  	handler: function(to, from) {
    	  	  	// alert(1)
    	  	  	let thePath = to.path
    	  	  	let fullPath = to.fullPath
    	  	  	if(thePath ===  '/mhome'){
    	  	  	  	thePath='/mHome'
    	  	  	  	fullPath='/mHome'
					}
    	  	  	for(let i=0;i<this.pathArr.length;i++){
					if(thePath == this.pathArr[i].pcPath){
						if(/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent) || this.isiPad()) {
						let mPath = fullPath.replace(this.pathArr[i].pcPath, this.pathArr[i].mPath)
							window.location.href = process.env.CTJZ_PLATFORM_PATH + mPath
						} else {
						return;
						}
					}
					if(thePath == this.pathArr[i].mPath){
						if(/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent) || this.isiPad()) {
							return;
						} else {
							let pcPath;
							if(thePath == '/mgoodsInfo'){
								pcPath = fullPath.replace(thePath, '/commodity-details')
							}else{
								pcPath = fullPath.replace(this.pathArr[i].mPath, this.pathArr[i].pcPath)
					console.log('tttttttt',pcPath,fullPath)
							}
							window.location.href = process.env.CTJZ_PLATFORM_PATH + pcPath
						}
					}
    	  	  	}
    	  	  	let url = process.env.LIB_PLATFORM_PATH+to.path
    	  	  	let name = to.meta.title
    	  	  	if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    	  	  	  	// return;
    	  	  	  	this.getAsyncSave(url,name,'mweb')
    	  	  	} else {
    	  	  	  	this.getAsyncSave(url,name,'PC')
    	  	  	}
    	  	}
    	}
	},
	methods:{
    	getAsyncSave(url,name,platform){
    	  	let params = {}
    	  	let paramsBody = {
    	  	  appCode: 'cbzx',
    	  	  url: url,
    	  	  name: name,
    	  	  platform: platform
    	  	}
    	  	asyncSave(params,paramsBody).then(res=>{
    	  	  console.log('resresres',res.data)
    	  	})
    	},
    	isiPad() {
    	    return (/macintosh|mac os x/i.test(navigator.userAgent) && window.screen.height > window.screen.width && !navigator.userAgent.match(/(iPhone\sOS)\s([\d_]+)/)) || navigator.userAgent.match(/(iPad).*OS\s([\d_]+)/);
    	}
	}  
}
</script>


<style>
*{
  font-family: '黑体';
  margin:0;
  padding:0;
}
a{
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue